import type { CartItem } from "@model/Cart.model";
import { CART_SET_ALL } from "./CartActionTypes";

export const setCartAllAction =
  (items?: CartItem[]) =>
  (dispatch: any) => {
    dispatch({ type: CART_SET_ALL, payload: { items } });
  };
